import React, { useState, useEffect } from "react";
import { ThemeContext, themes } from "contexts/ThemeContext";

export const THEME_STORAGE_KEY = "sistema-pedidos-theme";

export const readStoredTheme = () => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === themes.light || stored === themes.dark) return stored;
  } catch (e) {
    // ignore
  }
  return themes.light;
};

export const applyThemeToBody = (theme) => {
  if (theme === themes.light) {
    document.body.classList.add("white-content");
  } else {
    document.body.classList.remove("white-content");
  }
};

export default function ThemeContextWrapper(props) {
  const [theme, setTheme] = useState(readStoredTheme);

  function changeTheme(nextTheme) {
    setTheme(nextTheme);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
    } catch (e) {
      // ignore
    }
  }

  useEffect(() => {
    applyThemeToBody(theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
}
